import { Injectable, computed, signal } from '@angular/core';

/**
 * Full-screen loader (see {@link DkGlobalLoaderComponent} in app shell).
 * Use ref-counting so nested show/hide pairs stay balanced.
 */
@Injectable({ providedIn: 'root' })
export class GlobalLoaderService {
    private readonly depth = signal(0);

    readonly visible = computed(() => this.depth() > 0);

    show(): void {
        this.depth.update((d) => d + 1);
    }

    hide(): void {
        this.depth.update((d) => Math.max(0, d - 1));
    }
}
